import React from 'react';
import { Check } from 'lucide-react';
export function RevelationSection() {
  return <section className="bg-dark py-20 px-4" data-id="element-129">
      <div className="max-w-[900px] mx-auto flex flex-col items-center text-center" data-id="element-130">
        <h2 className="md:text-5xl font-extrabold text-white mb-8 text-[28px]" data-id="element-131">
          No todo lo que haces suma.
        </h2>

        <div className="text-lg md:text-xl text-white mb-10 space-y-4 max-w-3xl" data-id="element-132">
          <p data-id="element-133">No es tu tiempo.</p>
          <p data-id="element-134">Es en qué lo estás usando.</p>
          <p data-id="element-135">
            Estás sosteniendo actividades que no están construyendo crecimiento,
            y eso tiene un costo:
          </p>
        </div>

        <div className="flex flex-col items-start text-left gap-4 mb-12 w-full max-w-md mx-auto" data-id="element-136">
          <div className="flex items-center gap-3" data-id="element-137">
            <Check className="text-accent shrink-0" size={24} data-id="element-138" />
            <span className="text-xl text-white font-medium" data-id="element-139">
              menos ingresos,
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-140">
            <Check className="text-accent shrink-0" size={24} data-id="element-141" />
            <span className="text-xl text-white font-medium" data-id="element-142">
              menos claridad,
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-143">
            <Check className="text-accent shrink-0" size={24} data-id="element-144" />
            <span className="text-xl text-white font-medium" data-id="element-145">menos vida.</span>
          </div>
        </div>

        <p className="text-2xl text-white font-bold" data-id="element-146">
          Lo que no se corrige, se repite.
        </p>
      </div>
    </section>;
}